// extracted by mini-css-extract-plugin
export default {"announcement-admin-modal":"styles_announcement-admin-modal__iGqvj","detail-link":"styles_detail-link__0ZxN9"};